import { FormControl, FormGroup } from '@angular/forms';
import { EquipmentModel } from './symbols';

interface EquipmentControls {
  name: FormControl;
  power: FormControl;
  sn: FormControl;
  id: FormControl;
  launchAt: FormControl;
  talons: FormControl;
  contracts: FormControl;
  orders: FormControl;
  stands: FormControl;
  preparationForUse: FormControl;
  isNotOurs: FormControl;
}

export const equipmentSelectedHelper = (formGroup: FormGroup<EquipmentControls>, equipmentSelected: EquipmentModel) => {
  const talonsArray = formGroup.controls.talons;
  const contractsArray = formGroup.controls.contracts;
  const preparationForUseArray = formGroup.controls.preparationForUse;
  const standsArray = formGroup.controls.stands;
  const ordersArray = formGroup.controls.orders;


  if (!equipmentSelected) {
    formGroup.patchValue({ id: null });
    talonsArray.patchValue([], { emitEvent: false });
    contractsArray.patchValue([], { emitEvent: false });
    preparationForUseArray.patchValue([], { emitEvent: false });
    standsArray.patchValue([], { emitEvent: false });
    ordersArray.patchValue([], { emitEvent: false });

  } else {
    talonsArray.patchValue(equipmentSelected?.talons || [], { emitEvent: false });
    contractsArray.patchValue(equipmentSelected.contracts || [], { emitEvent: false });
    preparationForUseArray.patchValue(equipmentSelected?.preparationForUse || [], { emitEvent: false });
    standsArray.patchValue(equipmentSelected?.stands || [], { emitEvent: false });
    ordersArray.patchValue(equipmentSelected?.orders || [], { emitEvent: false });

    formGroup.patchValue({
      id: equipmentSelected.id,
      name: equipmentSelected.name,
      power: equipmentSelected.power,
      launchAt: equipmentSelected.launchAt,
      isNotOurs: equipmentSelected.isNotOurs
    });
  }
};

export const equipmentFillFormHelper = (formGroup: FormGroup<EquipmentControls>, prevEquipment: Partial<EquipmentModel>, currEquipment: Partial<EquipmentModel>) => {
  const preparationForUse = formGroup.controls.preparationForUse;
  const talonsArray = formGroup.controls.talons;
  const contractsArray = formGroup.controls.contracts;
  const ordersArray = formGroup.controls.orders;
  const standsArray = formGroup.controls.stands;

  if (currEquipment?.id) {
    if (prevEquipment?.id !== currEquipment?.id) {
      talonsArray.patchValue(currEquipment?.talons || []);
      contractsArray.patchValue(currEquipment?.contracts || []);
      preparationForUse.patchValue(currEquipment?.preparationForUse || []);
      ordersArray.patchValue(currEquipment?.orders || []);
      standsArray.patchValue(currEquipment?.stands || []);
    }
  } else {
    talonsArray.patchValue([]);
    contractsArray.patchValue([]);
    preparationForUse.patchValue([]);
    ordersArray.patchValue([]);
    standsArray.patchValue([]);
  }
};
